import { html } from 'lit';
const Shared =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.601 3.315a.75.75 0 0 1 .807.128l6.095 5.5a.75.75 0 0 1 0 1.114l-6.095 5.5A.75.75 0 0 1 14.156 15v-2.735c-2.614.106-4.1.76-4.92 1.345-.45.322-.715.633-.862.847a2 2 0 0 0-.166.29v.002A.75.75 0 0 1 6.75 14.5c0-3.006 1.322-4.981 3.035-6.177 1.4-.978 3.035-1.42 4.37-1.539V4a.75.75 0 0 1 .446-.685m-5.996 8.911c1.227-.793 3.191-1.476 6.3-1.476a.75.75 0 0 1 .75.75v1.813L19.882 9.5l-4.225-3.813V7.5a.75.75 0 0 1-.75.75c-1.202 0-2.894.347-4.262 1.302-.866.605-1.619 1.462-2.039 2.675" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M6 5.75c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h11c.69 0 1.25-.56 1.25-1.25v-2a.75.75 0 0 1 1.5 0v2A2.75 2.75 0 0 1 17 20.75H6A2.75 2.75 0 0 1 3.25 18V7A2.75 2.75 0 0 1 6 4.25h4a.75.75 0 0 1 0 1.5z" clip-rule="evenodd"/>
  </svg>
`;
export default Shared;
